

import React from "react";
import styles from "../../asset/Service/Artwork.module.scss";
import WhoWeAreImage from "../../asset/homefour/digitizing/digitizing1.webp"
import WhoWeAreImage2 from "../../asset/homefour/digitizing/digitizing2.webp"
import WhoWeAreImage3 from "../../asset/homefour/digitizing/digitizing3.webp"
import WhoWeAreImage4 from "../../asset/homefour/digitizing/digitizing4.webp"
import { Link } from "react-router-dom";


const Embroidery = () => {
    const artworks = [
        {
            img: WhoWeAreImage,
            title: "Regular Embroidery",
      link: "/portfolio/2",
        },
        {
            img: WhoWeAreImage2,
            title: "Puff & 3D Embroidery",
      link: "/portfolio/6",
        },
        {
            img: WhoWeAreImage3,
            title: "Applique",
      link: "/portfolio/9",
        },
        {
            img: WhoWeAreImage4,
            title: "Patches & Badges",
      link: "/portfolio/10",
        },
    ];

    return (
        <section className={styles.artworkSection}>
            <div className={styles.container}>
                <h2 className={styles.title}>Embroidery Digitizing</h2>
                <p className={styles.description}>
                    Stand-out embroidery designs on garments, bags, headwear, uniforms, and various accessories begin with high-quality custom embroidery digitizing. This process converts your design into a digital embroidery file that can be read by any embroidery machine.
                </p>

                <p className={styles.description}>
                    Our digitizing capabilities include name drops, lettering, logos, appliqué, sequins, 3D puff, chenille, and motifs. Texture and depth are added using thread colors that match your design, with a variety of fill types such as satin stitch, complex fill, run stitch, triple run, motif, backstitch, and manual stitch.

                </p>
                <p className={styles.description}>
                    Logos, monograms, emblems, and virtually any design can be digitized precisely to your specifications—ready to be sewn by your embroidery machine on a wide range of substrates.
                </p>

                <div className={styles.grid}>
                    {artworks.map((item, index) => (
                        <div key={index} className={styles.card}>
                            <img src={item.img} alt={item.title} className={styles.image} />
                            <div className={styles.cardContent}>
                                <h3>{item.title}</h3>
                               <Link to={item.link} className={styles.arrowBtn}>
    →
  </Link>
                            </div>
                        </div>
                    ))}
                </div>

                {/* <div className={styles.faqSection}>
                    <p>
                        Want to know more? Look up our FAQ page or speak to our responsive
                        customer support team.
                    </p>
                    <button className={styles.faqBtn}>Let's get started</button>
                </div> */}
            </div>
        </section>
    );
};

export default Embroidery;
